import { formatDate } from "./dateFormat";

function getTimeZoneString() {
   return new window.Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function convertTZ(date) {
   //applying local timezone to db date
   if (date != null) {
      return new Date(
         (typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {
            timeZone: getTimeZoneString()
         })
      );
   } else {
      return null;
   }
}

export function getFormattedDate(date) {
   return formatDate(date, { year: "numeric", month: "numeric", day: "numeric" });
}

export function getStringDate(date) {
   return formatDate(date, { year: "numeric", month: "long", day: "numeric" });
}

export function getFullDateTime(date) {
   if (date == null) return "";
   const timeZoneConvertedTime = convertTZ(date);
   const mdate = getDatepickerDateFromDate(timeZoneConvertedTime);
   const datePart = formatDate(mdate, { year: "numeric", month: "long", day: "numeric" });
   const timePart = formatDate(mdate, { hour: "numeric", minute: "2-digit", hour12: false });
   if (!datePart) return "";

   return " " + datePart + "  " + timePart + " ";
}

export function getTime(date) {
   return formatDate(date, { hour: "numeric", minute: "2-digit", hour12: false });
}

export function setTime12(date) {
   //to protect day skip because of timezone
   date.setHours(12, 0, 0, 0);
}

export function getYear(date) {
   const year = date?.getFullYear();

   return year;
}

export function getDateFromDatePicker(date) {
   const timeZonedDate = convertTZ(date);

   if (timeZonedDate != null) {
      const day = timeZonedDate.getDate();
      const month = timeZonedDate.getMonth() + 1;
      const year = timeZonedDate.getFullYear();

      return `${year}-${month}-${day}`;
   } else {
      return null;
   }
}

export function fromDatepickerToISO(date) {
   const timeZonedDate = convertTZ(date);

   if (timeZonedDate != null) {
      return date.toISOString();
   } else {
      return date.toISOString();
   }
}

export function fromISOtoDateTime(date) {
   const timeZonedDate = convertTZ(date);

   if (timeZonedDate != null) {
      return new Date(date);
   } else {
      return new Date(date);
   }
}

export function getDatepickerDateFromDate(date) {
   return new Date(date);
}

export function formatDateString(inputDateString) {
   return formatDate(inputDateString, { year: "numeric", month: "short", day: "numeric" });
}

